/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 */
import { useEffect } from 'react';
import { setScrollMode } from '../utils/scrollMode';

/** Lock page scroll during gameplay; allow scroll on landing / start screen. */
export function useGameScrollMode(showLanding: boolean, gameStarted: boolean): void {
  useEffect(() => {
    if (showLanding) {
      setScrollMode('page');
    } else if (!gameStarted) {
      setScrollMode('start-screen');
    } else {
      setScrollMode('locked');
    }
    return () => setScrollMode('page');
  }, [showLanding, gameStarted]);
}